import { useState, useEffect } from 'react';
import ProductCard from './ProductCard';
import LoadingDots from './LoadingDots';

// Recibe products ya filtrados por servidor+hook. Solo aplica sortBy client-side.
export default function ProductGrid({ products = [], isLoading, error, sortBy }) {
  const [sortedProducts, setSortedProducts] = useState([]);

  useEffect(() => {
    let sorted = [...products];

    switch (sortBy) {
      case 'price-low':
        sorted.sort((a, b) => a.price - b.price);
        break;
      case 'price-high':
        sorted.sort((a, b) => b.price - a.price);
        break;
      case 'name':
        sorted.sort((a, b) => a.name.localeCompare(b.name));
        break;
      case 'newest':
        sorted.sort((a, b) => {
          if (a.badge === 'launch' && b.badge !== 'launch') return -1;
          if (a.badge !== 'launch' && b.badge === 'launch') return 1;
          return 0;
        });
        break;
      case 'featured':
      default:
        // Orden manual desde Medusa (metadata.orden).
        // Menor número primero; productos sin "orden" caen al final en el orden actual.
        sorted.sort((a, b) => {
          const ao = a.orden;
          const bo = b.orden;
          if (ao == null && bo == null) return 0;
          if (ao == null) return 1;
          if (bo == null) return -1;
          return ao - bo;
        });
        break;
    }

    setSortedProducts(sorted);
  }, [products, sortBy]);

  if (error) {
    return (
      <div className="flex flex-col items-center justify-center py-20 text-center bg-[var(--phys-snow)]">
        <p className="text-sm text-red-600 font-light mb-2">Error al cargar productos</p>
        <p className="text-xs text-[#666]">{error}</p>
      </div>
    );
  }

  return (
    <div className="relative min-h-[400px] w-full">
      {isLoading && <LoadingDots overlay={true} />}

      <div className={`
        grid grid-cols-2 md:grid-cols-2 lg:grid-cols-4 xl:grid-cols-4 2xl:grid-cols-5
        transition-opacity duration-300
        ${isLoading ? 'opacity-40' : 'opacity-100'}
      `}>
        {sortedProducts.map((product, index) => (
          <div
            key={product.id}
            className="phys-fadeup bg-[var(--phys-snow)] border-r border-b border-[var(--phys-frost)] h-full"
            style={{ animationDelay: `${index > 7 ? 0.56 : index * 0.07}s` }}
          >
            <ProductCard product={product} />
          </div>
        ))}
      </div>

      {!isLoading && sortedProducts.length === 0 && (
        <div className="flex flex-col items-center justify-center py-20 text-center bg-[var(--phys-snow)]">
          <p className="text-sm text-[#666] font-light">
            No se encontraron productos.
          </p>
        </div>
      )}
    </div>
  );
}
